import React from 'react';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import * as brokerageOfferFlowSelectors from '../../store/brokerageOfferFlow/selectors';

import PriceJustification, {
  IProps as IPriceJustificationProps,
} from '../../components/brokerageOfferFlow/PriceJustification';
import { brokerageOfferPath } from '../../routes/pathBuilders';
import OfferLayout, { IProps as OfferLayoutProps } from './OfferLayout';

type IPriceJustificationPageProps = Partial<OfferLayoutProps> & IPriceJustificationProps;

const PriceJustificationPage: React.SFC<IPriceJustificationPageProps> = props => {
  const prevUrl = brokerageOfferPath(props.match.params.token, 'welcome');
  const nextUrl = brokerageOfferPath(props.match.params.token, 'details');

  return (
    <OfferLayout
      disclaimerType="trusted-buyer"
      headerType="BROKERAGE"
      footerType="BROKERAGE"
      brokerageInfo={props.brokerageInfo}
      prevBtnUrl={prevUrl}
      prevBtnText={'Back'}
      primaryBtnUrl={nextUrl}
      primaryBtnText={'Offer details'}
    >
      <PriceJustification {...props} />
    </OfferLayout>
  );
};

const mapStateToProps = createSelector(
  brokerageOfferFlowSelectors.brokerageInfo,
  brokerageOfferFlowSelectors.brokerageOfferHeadlineCents,
  brokerageOfferFlowSelectors.odOfferHeadlineCents,
  brokerageOfferFlowSelectors.brokerageOfferFeePct,
  brokerageOfferFlowSelectors.odOfferFeePct,
  brokerageOfferFlowSelectors.brokerageOfferNetCents,
  brokerageOfferFlowSelectors.odOfferNetCents,
  brokerageOfferFlowSelectors.otherBids,
  (
    brokerageInfo,
    brokerageOfferHeadlineCents,
    odOfferHeadlineCents,
    brokerageOfferFeePct,
    odOfferFeePct,
    brokerageOfferNetCents,
    odOfferNetCents,
    otherBids,
  ): IPriceJustificationPageProps => {
    if (!otherBids) {
      return { brokerageInfo, offers: [] };
    }

    const offers = [
      {
        description:
          'One of our trusted buyer partners has offered to purchase your home for \
                      this price. This was your highest Initial Net Offer.',
        feePct: brokerageOfferFeePct,
        headlineCents: brokerageOfferHeadlineCents,
        isPresented: true,
        netCents: brokerageOfferNetCents,
        title: 'Buyer Partner Offer',
      },
      ...otherBids.toJS().map(offer => ({
        description:
          'One of our trusted buyer partners has offered to purchase your home for \
                      this price.',
        feePct: brokerageOfferFeePct,
        headlineCents: offer['headline_cents'],
        isPresented: false,
        netCents: offer['net_cents'],
        title: 'Buyer Partner Offer',
      })),
    ];

    // don't add od offer when it's unavailable
    if (odOfferHeadlineCents) {
      offers.push({
        description:
          "This is Opendoor's valuation of your home and what we anticipate your home \
                      would sell for on the open market if you were to list it today. It is also \
                      what Opendoor would have offered to purchase your home for.",
        feeLabel: 'Service charge',
        feePct: odOfferFeePct,
        headlineCents: odOfferHeadlineCents,
        isPresented: false,
        netCents: odOfferNetCents,
        title: 'Opendoor valuation',
      });
    }

    return { brokerageInfo, offers };
  },
);

export default connect(mapStateToProps)(PriceJustificationPage);
